import { render, staticRenderFns } from "./index-travel.vue?vue&type=template&id=79c7fbd2&"
import script from "./index-travel.vue?vue&type=script&lang=js&"
export * from "./index-travel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports